import { ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Channel, Company, Crew, Movie, MovieCrewRole, Star } from '@usheru-hff/shared/domain';
import { ImageService } from '@usheru-hff/shared/utils-image';
import { TranslationsService } from '@usheru-hff/shared/utils-translation';
import { ENVIRONMENT, Environment, MoreInfoParams } from '@environment';

/**
 * Component to display movie data related to movie information.
 *
 * //TODO barbeitoalex propostal - organice life cycle methods. Split in specific method to improve docs.
 * //TODO barbeitoalex propostal - update translate text with an observable to the current language
 */
@Component({
  selector: 'ush-movie-info-credits',
  templateUrl: './movie-info-credits.component.html',
  styleUrls: ['./movie-info-credits.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MovieInfoCreditsComponent implements OnInit, OnChanges {
  /**
   * @docNotNeccesary
   */
  @Input()
  movie!: Movie;

  /**
   * @docNotNeccesary
   */
  @Input()
  channel?: Channel;

  /**
   * @docNotNeccesary
   */
  @Input()
  showPortrait = true;

  /**
   * @docNotNeccesary
   */
  @Input()
  widthPortrait = 300;

  /**
   * Genre names list of the {@link movie}.
   */
  genres: string[] | undefined;

  /**
   * General release date text.
   */
  releaseDate: string | undefined;

  /**
   * Release date text of the active location ({@link LocationService})
   */
  locReleaseDate: string | undefined;

  /**
   * Sales agent enabled from environment.
   */
  salesAgentsEnabled: boolean;

  /**
   * Used to know what data show or hide. Setted from {@link Environment} moreInfoParams
   */
  infoParams: MoreInfoParams | undefined;

  /**
   * @docNotNeccesary
   */
  rightOwners: Company[] | undefined;

  /**
   * Hide the data under this component header. Setted from {@link Environment} movieInfoCollapse.
   */
  canCollapse = false;

  /**
   * Status used if {@link canCollapse} is enabled.
   */
  collapsed = false;

  /**
   * To show filmafinity link.
   */
  @Input() showTPAffinity: string;

  @Input() titleAsLink: string;

  /**
   * Enables show the {@link rightOwners}. Setted from {@link Environment} movieInfoShowRightOwners.
   */
  showRightOwners = false;

  salesAgentImgError: number[] = [];

  /**
   * Setted from {@link Environment} movieInfoMod
   * alPortrait
   */
  movieInfoModalPortrait = true;
  portraitPlaceholder: string;
  // director: string[];
  // producer: string[];
  // cast: string[];
  crewListing: CrewListing[] = [];

  constructor(
    private translationsService: TranslationsService,
    @Inject(ENVIRONMENT) private environment: Environment,
    private imageService: ImageService
  ) {
    this.canCollapse = this.environment?.customPageParams?.movieInfoCollapse || false;
    this.collapsed = (this.canCollapse && this.environment?.customPageParams?.movieInfoCollapseInitial) || false;
    // this.showTPAffinity = this.environment?.customPageParams?.movieInfoShowTPAffinity || false;
    this.showRightOwners = this.environment?.customPageParams?.movieInfoShowRightOwners || false;
    this.salesAgentsEnabled = environment?.enableSalesAgent;
    this.portraitPlaceholder = imageService.portraitPlaceholder;
    // Default is true and the user must set as false in the environemnt
    //TODO could be better know in what apps we need this clcklable with another card
    // this.movieInfoModalPortrait = this.environment.customPageParams?.movieInfoModalPortrait || true;
    this.movieInfoModalPortrait =
      this.environment?.customPageParams?.movieInfoModalPortrait == undefined
        ? true
        : this.environment.customPageParams.movieInfoModalPortrait;
  }

  /**
   * @docNotNeccesary
   */
  ngOnInit(): void {
    // assigning moreInfoParams fron env to infoParams if exits if not null
    this.setText();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      !changes['movie'].firstChange &&
      this.areNewValuesDifferent(changes['movie'].previousValue, changes['movie'].currentValue)
    ) {
      this.setText();
    }
  }

  areNewValuesDifferent(previousMovie: Movie, newMovie: Movie) {
    //review if friendlyUrl, countries, languages, genres, contractualPartners, releaseDate or locReleaseDate are different from previous movie
    if (
      previousMovie.movieCrew != newMovie.movieCrew ||
      previousMovie.friendlyUrl != newMovie.friendlyUrl ||
      previousMovie.countries != newMovie.countries ||
      previousMovie.languages != newMovie.languages ||
      previousMovie.genres != newMovie.genres ||
      previousMovie.contractualPartners != newMovie.contractualPartners ||
      previousMovie.releaseDate != newMovie.releaseDate ||
      previousMovie.locReleaseDate != newMovie.locReleaseDate
    ) {
      return true;
    }
  }

  setText() {
    this.infoParams = this.environment.moreInfoParams ? this.environment.moreInfoParams : undefined;
    if (this.environment.countriesPipe) this.environment.countriesPipe(this.movie.countries);
    this.genres = this.collect(this.movie.genres, genre => this.translationsService.translate(genre.trMsg));
    this.rightOwners = this.movie.contractualPartners;
    this.releaseDate = this.getReleaseDate(this.movie.releaseDate);
    this.locReleaseDate = this.getLocReleaseDate(this.movie.locReleaseDate);
    this.crewListing = [];
    const roles: MovieCrewRole[] = this.environment.movieCrew.movieCrewRoleListing;
    roles.forEach(role => {
      this.crewListing.push(this.getCrewListingByRole(role, this.movie.movieCrew));
    });
  }

  /**
   * Map a list of objects.
   * @param arr
   * @param mapper
   * @returns
   */
  private collect(arr: any[], mapper: (el: any) => string): string[] {
    if (arr && arr.length) {
      return arr.map(mapper).filter(el => el != null && el.length > 0);
    }

    return [];
  }
  onSalesAgentLogoError(index) {
    this.salesAgentImgError.push(index);
  }

  imgWithError(index) {
    return this.salesAgentImgError.includes(index);
  }

  /**
   * Gets a translate text from key.
   *
   * //TODO barbeitoalex propostal - change elem to str like to vi more calrify
   * @param elem
   * @returns
   */
  private translateString(elem: string) {
    return this.translationsService.translate(elem);
  }

  /**
   * Similar to {@link getReleaseDate}. Check TODO note.
   * @param releaseDate
   * @returns
   */
  getLocReleaseDate(releaseDate) {
    let dateFormat;
    if (!releaseDate) return null;
    const stringDate: string[] = releaseDate.split('-');
    const newString = stringDate[1] + '/' + stringDate[0] + '/' + stringDate[2];
    const d = new Date(newString);
    if (this.environment.moreInfoParams?.locReleaseDate) {
      switch (this.environment.moreInfoParams.locReleaseDate) {
        case 'year':
          dateFormat = {
            year: 'numeric'
          };
          break;
        case 'full' || null || undefined:
          dateFormat = {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          };
          break;
      }
    } else {
      dateFormat = {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      };
    }

    return new Date(d).toLocaleDateString('en', dateFormat);
  }

  /**
   * Get date string using {@link infoParams} format.
   *
   * //TODO barbeitoalex propostal - change this to able to merge with {@link getLocReleaseDate}
   * @param date
   * @returns
   */
  getReleaseDate(date) {
    if (!date) return null;
    const stringDate: string[] = date.split('-');
    const newString = stringDate[1] + '/' + stringDate[0] + '/' + stringDate[2];
    const d = new Date(newString);
    let dateFormat;
    if (this.environment.moreInfoParams?.locReleaseDate) {
      switch (this.environment.moreInfoParams.locReleaseDate) {
        case 'year':
          dateFormat = {
            year: 'numeric'
          };
          break;
        case 'full' || null || undefined:
          dateFormat = {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          };
          break;
      }
    } else {
      dateFormat = {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      };
    }
    return new Date(d).toLocaleDateString(this.translationsService.language.code, dateFormat);
  }

  /**
   * @docNotNeccesary
   * @param value
   */
  toggleCollapse(value?: boolean) {
    if (this.canCollapse) this.collapsed = value || !this.collapsed ? true : false;
  }

  getCreditsFromMovie(movie: Movie) {}
  /**
   * Gets crew that shared the same by rol.
   */
  private getCrewListingByRole(role: MovieCrewRole, movieCrew: Crew[]): CrewListing {
    const stars: Star[] = [];
    if (!movieCrew) return null;
    movieCrew
      .filter(crew => {
        return crew.crewRole.trMsg === role;
      })
      .sort((a, b) => a.position - b.position)
      .forEach(crew => stars.push(crew.star));

    if (stars.length > 0) {
      return {
        role,
        roleClass: this.getRoleClass(role),
        starList: stars
      };
    } else {
      return null;
    }
  }

  private getRoleClass(role: string) {
    return role.replace('crew.role.', '').replaceAll('.', '-').toLowerCase();
  }
}

interface CrewListing {
  role: MovieCrewRole;
  roleClass?: string;
  starList: Star[];
}
